'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LogoutIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LogoutIcon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_297_4642)">
          <path
            d="M8.99967 3.33325V0.999919C8.99967 0.823108 8.92944 0.653538 8.80441 0.528514C8.67939 0.40349 8.50982 0.333252 8.33301 0.333252H0.999674C0.822863 0.333252 0.653294 0.40349 0.52827 0.528514C0.403246 0.653538 0.333008 0.823108 0.333008 0.999919V14.9999C0.333008 15.1767 0.403246 15.3463 0.52827 15.4713C0.653294 15.5963 0.822863 15.6666 0.999674 15.6666H8.33301C8.50982 15.6666 8.67939 15.5963 8.80441 15.4713C8.92944 15.3463 8.99967 15.1767 8.99967 14.9999V12.6666"
            stroke={sx?.color || '#3D517B'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.6667 8H3"
            stroke={sx?.color || '#3D517B'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.333 11.3334L15.6663 8.00008L12.333 4.66675"
            stroke={sx?.color || '#3D517B'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

LogoutIcon.propTypes = {
  sx: PropTypes.object
}
